import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
import { getDateStringFromObject } from 'utils/timeUtils';
import { FARE_CALENDAR_ERROR } from 'constants/TravelConstants';
export var GetFareCalendarAction;
(function (GetFareCalendarAction) {
    GetFareCalendarAction["REQUEST"] = "GET_FARE_CALENDAR_REQUEST";
    GetFareCalendarAction["SUCCESS"] = "GET_FARE_CALENDAR_SUCCESS";
    GetFareCalendarAction["ERROR"] = "GET_FARE_CALENDAR_ERROR";
})(GetFareCalendarAction || (GetFareCalendarAction = {}));
export var IFareSearchType;
(function (IFareSearchType) {
    IFareSearchType["OUT"] = "OUT";
    IFareSearchType["RETURN"] = "RETURN";
})(IFareSearchType || (IFareSearchType = {}));
export function getFareCalendar(requestData) {
    /**
     * origin and dest are airport codes. They can by undefined.
     * startDate is only required for RETURN fares
     *
     * Departure fares: searchType: OUT without startDate.
     * Return fares: searchType RETURN with startDate mandatory.
     */
    const query = {
        origin: requestData.origin,
        dest: requestData.dest,
        searchType: requestData.startDate ? IFareSearchType.RETURN : IFareSearchType.OUT,
        startDate: requestData.startDate ? getDateStringFromObject(requestData.startDate) : undefined
    };
    // saves unnecessary API calls
    if (!query.origin || !query.dest) {
        return {
            type: GetFareCalendarAction.ERROR,
            error: FARE_CALENDAR_ERROR.EMPTY_CITY
        };
    }
    else if (query.origin === query.dest) {
        return {
            type: GetFareCalendarAction.ERROR,
            error: FARE_CALENDAR_ERROR.SAME_ORIGIN_DEST
        };
    }
    return (dispatch, _getState) => {
        /**
         * Comparing old state with new doesn't serve the purpose. Need a divide logic to show
         * depart and return calendar fares separately.
         * The current implementation has one fare data at a time. If user tries to fast switch between return and departure date,
         * the race condition might occur and data might disappear for current input selection, even though api call was successful
         */
        // const { FareCalendarData } = getState();
        // Not a good way to save api calls. This just saves subsequent calls to same url.
        // Also It's buggy since requestedQuery would only be present for successful calls (see FareCalendarReducer)
        // TODO: would be better to implement caching logic with some ttl.
        // const oldRequestedQuery = get(FareCalendarData, 'requestedQuery') || {};
        // if (!shallowEqual(oldRequestedQuery, query)) {
        dispatch({
            type: GetFareCalendarAction.REQUEST
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/2/flights/fare-lookup',
            query,
            acceptErrors: true,
            action: GetFareCalendarAction.REQUEST
        })).then(json => dispatch({
            type: GetFareCalendarAction.SUCCESS,
            data: json.RESPONSE,
            requestedQuery: query
        }), error => {
            dispatch({
                type: GetFareCalendarAction.ERROR,
                error
            });
        });
    };
}
